import { render } from "./CheckSwitch.vue?vue&type=template&id=74ef64a4&ts=true"
import script from "./CheckSwitch.vue?vue&type=script&lang=ts"
export * from "./CheckSwitch.vue?vue&type=script&lang=ts"

import "./CheckSwitch.vue?vue&type=style&index=0&id=74ef64a4&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__